import { useState } from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { type adaptPost } from "@/lib/api";
import { formatDateLong } from "@/lib/date";

type JournalPost = ReturnType<typeof adaptPost>;

export function JournalImage({ post, priority = false }: { post: JournalPost; priority?: boolean }) {
  const [failed, setFailed] = useState(false);
  return <div className="pf-journal-image">{post.coverImage && !failed ? <img src={post.coverImage} alt={post.title} loading={priority ? "eager" : "lazy"} decoding="async" onError={() => setFailed(true)} /> : <div className="pf-journal-image-fallback" aria-label={`Article : ${post.title}`}><span>Le journal / Tokam Darius</span><strong>{post.category || "Notes de développement"}</strong><ArrowUpRight size={48} aria-hidden="true" /></div>}</div>;
}

export function JournalMeta({ post }: { post: JournalPost }) {
  return <div className="pf-journal-meta"><time dateTime={post.publishedAt}>{formatDateLong(post.publishedAt)}</time><span>{post.readingTime} min de lecture</span></div>;
}

export function JournalCard({ post, index = 0 }: { post: JournalPost; index?: number }) {
  return <article className="pf-journal-card" data-slug={post.slug}>
    <Link className="pf-journal-image-link" to={`/blog/${post.slug}`} aria-label={`Lire : ${post.title}`}><JournalImage key={post.coverImage} post={post} /></Link>
    <div className="pf-journal-card-category"><span>{post.category}</span><span aria-hidden="true">{String(index + 1).padStart(2, "0")}</span></div>
    <h3><Link to={`/blog/${post.slug}`}>{post.title}</Link></h3>
    <p className="pf-journal-excerpt">{post.excerpt}</p>
    <ul className="pf-journal-tags" aria-label="Sujets">{post.tags.slice(0, 3).map(tag => <li key={tag}>{tag}</li>)}</ul>
    <div className="pf-journal-card-bottom"><JournalMeta post={post} /><Link className="pf-text-link" to={`/blog/${post.slug}`}>Lire l'article <ArrowUpRight size={17} aria-hidden="true" /></Link></div>
  </article>;
}
